export default "__VITE_PUBLIC_ASSET__e0752b02__"